import styled, { DefaultTheme } from "styled-components";
// import { lightColors } from "../../theme/colors";
import { Text } from "@edricphan2022/uikit";
import { StyledDropdownMenuItemProps } from "./types";

const getTextColor = ({
  $isActive,
  disabled,
  theme,
}: StyledDropdownMenuItemProps & { theme: DefaultTheme; $isActive: boolean }) => {
  if (disabled) return "#2E2E2E;";
  if ($isActive) return "#2E2E2E;";

  return "#2E2E2E;";
};

export const DropdownMenuItem = styled.button<StyledDropdownMenuItemProps & { $isActive: boolean }>`
  border: 0;
  background: transparent;
  color: ${({ theme, disabled, $isActive }) => getTextColor({ theme, disabled, $isActive })};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  font-weight: ${({ $isActive = false }) => ($isActive ? "600" : "400")};
  display: flex;
  font-size: 16px;
  height: 48px;
  justify-content: space-between;
  outline: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 4px;
  border-bottom: 0.5px solid #aaaaaa;
  width: 100%;

  align-items: center;
  justify-content: center;
  &:hover:not(:disabled) {
    color: #ffc42a;
  }

  &:active:not(:disabled) {
    opacity: 0.85;
    transform: translateY(1px);
  }
`;

export const StyledDropdownMenuItemContainer = styled.div`
  &:first-child > ${DropdownMenuItem} {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child > ${DropdownMenuItem} {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border: none;
  }
`;

export const DropdownMenuDivider = styled.hr`
  border-color: ${({ theme }) => theme};
  border-style: solid;
  border-width: 1px 0 0;
  margin: 4px 0;
`;

export const StyledDropdownMenu = styled.div<{ $isOpen: boolean; $isBottomNav: boolean }>`
  background-color: #fffdf6;
  box-shadow: 0px 4px 10px rgba(208, 214, 227, 0.7);
  border-radius: 20px;
  padding-bottom: 4px;
  padding-top: 4px;
  pointer-events: auto;
  width: ${({ $isBottomNav }) => ($isBottomNav ? "calc(100% - 32px)" : "194px")};
  visibility: visible;
  z-index: 1001;

  ${({ $isOpen }) =>
    !$isOpen &&
    `
    pointer-events: none;
    visibility: hidden;
  `}
`;

export const LinkStatus = styled(Text)<{ color?: string }>`
  border-radius: 4px;
  padding: 0 8px;
  border: 2px solid;
  border-color: blue;
  box-shadow: none;
  color: ${({ color }) => color || "#fff "};
  margin-left: 8px;
`;
